import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { forwardRef, useState } from "react";
import { useProps } from "./auth-service-tools225.js";
import { Box } from "./auth-service-tools244.js";
import { ScrollAreaProvider } from "./auth-service-tools543.js";
import { useMergedRef } from "./auth-service-tools278.js";
const defaultProps = {
  scrollHideDelay: 1e3,
  type: "hover"
};
const ScrollAreaRoot = /*#__PURE__*/forwardRef((_props, ref) => {
  const props = useProps("ScrollAreaRoot", defaultProps, _props);
  const {
    type,
    scrollHideDelay,
    scrollbars,
    ...others
  } = props;
  const [scrollArea, setScrollArea] = useState(null);
  const [viewport, setViewport] = useState(null);
  const [content, setContent] = useState(null);
  const [scrollbarX, setScrollbarX] = useState(null);
  const [scrollbarY, setScrollbarY] = useState(null);
  const [cornerWidth, setCornerWidth] = useState(0);
  const [cornerHeight, setCornerHeight] = useState(0);
  const [scrollbarXEnabled, setScrollbarXEnabled] = useState(false);
  const [scrollbarYEnabled, setScrollbarYEnabled] = useState(false);
  const rootRef = useMergedRef(ref, node => setScrollArea(node));
  return /* @__PURE__ */jsxRuntimeExports.jsx(ScrollAreaProvider, {
    value: {
      type,
      scrollHideDelay,
      scrollArea,
      viewport,
      onViewportChange: setViewport,
      content,
      onContentChange: setContent,
      scrollbarX,
      onScrollbarXChange: setScrollbarX,
      scrollbarXEnabled,
      onScrollbarXEnabledChange: setScrollbarXEnabled,
      scrollbarY,
      onScrollbarYChange: setScrollbarY,
      scrollbarYEnabled,
      onScrollbarYEnabledChange: setScrollbarYEnabled,
      onCornerWidthChange: setCornerWidth,
      onCornerHeightChange: setCornerHeight
    },
    children: /* @__PURE__ */jsxRuntimeExports.jsx(Box, { ...others,
      ref: rootRef,
      __vars: {
        "--sa-corner-width": scrollbars !== "xy" ? "0px" : `${cornerWidth}px`,
        "--sa-corner-height": scrollbars !== "xy" ? "0px" : `${cornerHeight}px`
      }
    })
  });
});
ScrollAreaRoot.displayName = "@mantine/core/ScrollAreaRoot";
export { ScrollAreaRoot };